<template>
  <div class="mx-2">
    <v-card class="card_container" style="z-index: 0">
      <v-card-title
        style="background-color: #82a1d0; position: sticky; top: 0; z-index: 0"
        background-color="primary"
        class="d-flex justify-space-between align-center"
      >
        <v-row class="pl-3">
          <v-text-field
            dense
            solo
            v-model="search"
            append-icon="mdi-magnify"
            :label="$tc('commons.search')"
            single-line
            hide-details
            class="search"
          />
          <div class="filter-search-container ml-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="handleItemsSelect"
                  color="blue-grey darken-1"
                  icon
                  class="ml-1"
                >
                  <v-icon>mdi-tag-plus</v-icon>
                </v-btn>
              </template>
              <span>Asignar etiquetas</span>
            </v-tooltip>

            <v-dialog v-model="tagDialog" max-width="400px">
              <v-card class="pa-0">
                <v-card-title class="d-flex justify-center">
                  {{
                    showAddTag === false
                      ? "Asignar etiquetas"
                      : "Agregar etiqueta nueva"
                  }}
                </v-card-title>
                <v-tooltip bottom v-if="!showAddTag">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      class="add-tag"
                      v-bind="attrs"
                      v-on="on"
                      @click="showAddTag = true"
                      >mdi-tag-plus</v-icon
                    >
                  </template>
                  <span>Agregar etiqueta</span>
                </v-tooltip>

                <v-card-text :class="{ 'mt-n5': showAddTag == false }">
                  <v-form ref="form" v-model="formValid" v-if="!showAddTag">
                    <v-autocomplete
                      v-model="selectedRow"
                      :items="getReports"
                      item-value="id"
                      item-text="name"
                      label="Selecciona un reporte"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Este campo es requerido']"
                    />
                    <v-autocomplete
                      v-model="selectedTagsGroup"
                      :items="getTagsFilter(selectedRow)"
                      item-value="id"
                      item-text="text"
                      label="Selecciona etiquetas"
                      multiple
                      outlined
                      dense
                      chips
                      :disabled="!selectedRow"
                      :rules="[
                        (v) =>
                          (!!v && v.length > 0) || 'Este campo es requerido',
                      ]"
                    >
                      <template v-slot:item="data">
                        <div style="display: flex; align-items: center">
                          <div
                            :style="{
                              backgroundColor: data.item.color,
                              width: '20px',
                              height: '20px',
                              marginRight: '10px',
                            }"
                          ></div>
                          <span>{{ data.item.text }}</span>
                        </div>
                      </template>
                      <template v-slot:selection="data">
                        <v-chip
                          :key="data.item.id"
                          :color="data.item.color"
                          text-color="white"
                          close
                          small
                          @click:close="removeTag(data.item)"
                        >
                          {{ data.item.text }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-form>
                  <v-form ref="form" v-model="formValid" v-else>
                    <v-text-field
                      name="text"
                      v-model="name"
                      :label="this.$tc('reports.labelsTitle')"
                      outlined
                      :rules="rules"
                      dense
                      class="ma-0"
                    />
                    <v-text-field
                      name="description"
                      v-model="description"
                      :label="this.$tc('reports.labelsDescription')"
                      outlined
                      :rules="rules"
                      dense
                      class="ma-0"
                    />
                    <v-color-picker
                      v-model="color"
                      class="mx-auto mb-4"
                      :swatches="swatches"
                      show-swatches
                      hide-canvas
                      hide-sliders
                      hide-inputs
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-space-between mt-n5">
                  <v-btn
                    color="red"
                    text
                    @click="cancelDialogTag"
                    v-if="!showAddTag"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn color="red" text @click="showAddTag = false" v-else
                    >Cancelar</v-btn
                  >
                  <v-btn
                    color="primary"
                    text
                    @click="validateAndSave"
                    :disabled="!formValid"
                    v-if="!showAddTag"
                  >
                    Aceptar
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="addTag()"
                    :disabled="!formValid"
                    v-else
                  >
                    Aceptar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <div>
              <v-autocomplete
                v-model="selected"
                small-chips
                dense
                solo
                hide-details
                append-icon="mdi-tag-multiple"
                :label="$tc('commons.group')"
                class="autocomplete"
                :items="tags"
                item-text="text"
                item-value="id"
                multiple
                flat
                @input="changesTags()"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < 1"
                    :color="item.color"
                    id="chip-tags"
                    small
                    close
                    @click:close="selected.splice(index, 1)"
                  >
                    <span>{{ item.text }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+ {{ selected.length - 1 }} )
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <v-chip id="chip-tags" small :color="item.color">
                    {{ item.text }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </v-row>

        <v-col cols="auto" class="my-n4 pr-0">
          <v-row class="justify-start border ma-0">
            <!-- Botón de Refresh -->
            <v-col cols="auto" class="pa-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="refreshItems"
                    class="btn-table ma-1"
                    small
                  >
                    <v-icon
                      :class="{ loader: loading4 }"
                      :loading="loading4"
                      :disabled="loading4"
                      id="icon-add"
                      class="mx-auto"
                      size="19"
                    >
                      fas fa-sync-alt
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("commons.refresh") }}</span>
              </v-tooltip>
            </v-col>
            <!-- Botón de Configurar Columnas -->
            <v-col cols="auto pa-0">
              <div class="d-flex justify-center">
                <v-dialog
                  v-model="btnConfigColumns.menu"
                  max-width="400px"
                  @keydown.esc="toggleColumnMenu"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          dark
                          icon
                          @click="toggleColumnMenu"
                          v-bind="attrs"
                          v-on="on"
                          class="btn-table ma-1"
                          small
                        >
                          <v-icon size="20">{{ btnConfigColumns.icon }}</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ btnConfigColumns.tooltip }}</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-text-field
                      v-model="columnFilter"
                      placeholder="Buscar columnas"
                      outlined
                      dense
                      hide-details
                      class="pa-2 pb-0 ma-0"
                    ></v-text-field>
                    <div
                      style="
                        min-width: 250px;
                        max-height: 250px;
                        overflow-y: scroll;
                        scrollbar-width: unset;
                      "
                      class="pa-2 pb-0 ma-0"
                      hide-details
                    >
                      <div
                        v-if="filteredColumns?.length === 0"
                        class="text-center px-2 pb-2"
                      >
                        <span
                          >No hay resultados que coincidan con la búsqueda</span
                        >
                      </div>
                      <div v-else>
                        <div
                          v-for="column in filteredColumns"
                          :key="column.field"
                          hide-details
                        >
                          <v-checkbox
                            v-model="column.visible"
                            :label="column.text"
                            hide-details
                            class="my-auto mb-2"
                          ></v-checkbox>
                        </div>
                      </div>
                    </div>
                    <v-card-actions class="d-flex justify-space-between">
                      <v-btn class="bt-exit" @click="toggleColumnMenu">
                        <v-icon>fas fa-times</v-icon>
                      </v-btn>

                      <v-btn
                        color="bt-acept"
                        @click="
                          headersUpdated();
                          toggleColumnMenu();
                        "
                      >
                        <v-icon>fas fa-save</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-col>
            <!-- Botón de Añadir -->
            <v-col cols="auto pa-0">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="white" dark icon class="btn-table ma-1" small>
                      <v-icon
                        size="20"
                        class="mx-auto"
                        id="icon-add"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialog('add')"
                      >
                        fas fa-plus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $tc("commons.add") }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <div class="mr-5" v-if="showValidateProcess">
          <v-tooltip bottom class="ma-2">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                size="30"
                color="white"
                v-bind="attrs"
                v-on="on"
                @click="openDialog('validate')"
              >
                mdi-sort-bool-ascending-variant
              </v-icon>
            </template>
            <span>{{ $tc("workflow.validateProcess") }}</span>
          </v-tooltip>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :search="search"
        :hide-default-footer="true"
        disable-pagination
        :headers="visibleHeaders"
        :items="filterForTags"
        style="min-width: 100%"
        :calculate-widths="true"
        @click:row="goToItem"
        v-sortable-columns="saveColumnOrder"
        :key="tableKey"
        item-key="index"
        fixed-header
        :height="tableHeight"
        class="elevation-3 pa-0 ma-0"
      >
        <template v-slot:header.actions="{ header }">
          <span class="d-flex justify-center">
            {{ header.text }}
          </span>
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="ma-0 pa-0">
            <v-chip
              id="chip-tags"
              class="ma-1"
              v-for="tag in item.tags"
              :key="tag.etiquetaId"
              small
              @click="handleChipClick(tag.etiquetaId)"
              :color="tag.color"
            >
              {{ tag.nombre }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.color="{ item }">
          <div
            class="mx-auto"
            style="width: 25px; height: 25px"
            :style="{ backgroundColor: item.color }"
          />
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-space-around" style="width: 100px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-show="localShowEdit">
                  <v-btn
                    :disabled="shouldShowDeleteButton(item)"
                    icon
                    :plain="shouldShowDeleteButton(item)"
                  >
                    <v-icon
                      id="icon-edit"
                      :disabled="
                        !(
                          item.permission === 'P' ||
                          item.permission === 'C' ||
                          item.permission === undefined ||
                          item.permission === null
                        )
                      "
                      @click="openDialog('edit', item, $event)"
                    >
                      fas fa-pen
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $tc("commons.edit") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn
                    :disabled="shouldShowDeleteButton(item)"
                    icon
                    :plain="shouldShowDeleteButton(item)"
                  >
                    <v-icon
                      id="icon-delete"
                      :disabled="
                        !(
                          item.permission === 'P' ||
                          item.permission === undefined ||
                          item.permission === null
                        )
                      "
                      @click="openDialog('delete', item, $event)"
                    >
                      fas fa-trash
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $tc("commons.delete") }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="showIcon">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div>
                    <v-img
                      src="@/assets/icons/actualizar.png"
                      style="cursor: pointer"
                      alt="eliminar"
                      max-width="25"
                      class="mt-2 mr-3"
                      :disabled="
                        !(
                          item.permission === 'P' ||
                          item.permission === 'C' ||
                          item.permission === 'L' ||
                          item.permission === undefined ||
                          item.permission === null
                        )
                      "
                      @click="openDialog('exe', item, $event)"
                      v-if="executeButtonEnabled(item)"
                    />
                  </div>
                </span>
              </template>
              <span>{{ $tc("reports.exe") }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="showIcon">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn icon>
                    <v-icon
                      id="icon-edit"
                      :disabled="
                        !(
                          item.permission === 'P' ||
                          item.permission === undefined ||
                          item.permission === null
                        )
                      "
                      @click="openDialog('pass', item, $event)"
                    >
                      fas fa-user-lock
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $tc("reports.assignPasses") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <div v-if="showPagination" class="mt-2">
      <v-pagination
        v-model="currentPage"
        :length="Math.ceil(items.length / itemsPerPage)"
        prev-icon="mdi-chevron-left"
        next-icon="mdi-chevron-right"
        hide-delimiter-background
        :items-per-page="itemsPerPage"
        :max="Math.min(10, Math.ceil(items.length / itemsPerPage))"
        :total-visible="Math.min(10, Math.ceil(items.length / itemsPerPage))"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import ToolbarTitles from "../../Complement/ToolbarTitles.vue";
import Sortable from "sortablejs";
import reports from "../../../store/reportes/reports";

export default {
  components: { ToolbarTitles },
  props: {
    executeButtonEnabled: Function,
    headers: Array,
    items: Array,
    title: String,
    goToItem: {
      type: Function,
      default: () => {},
    },
    openDialog: Function,
    saveConfigColums: Function,
    showEdit: {
      type: Boolean,
      default: true,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    itemsPerPage: {
      type: Number,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    showValidateProcess: {
      type: Boolean,
      default: false,
    },
    showFilterTags: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
    },
  },
  mounted() {
    this.$store.dispatch("tags/getTags");
    reports.dispatch("getReports");
  },
  data() {
    return {
      tableHeight: this.calculateMaxHeight(),
      formValid: false,
      selectedTags: [],
      selectedTagsGroup: [],
      selectedRow: [],
      selected: [],
      search: "",
      searchTags: "",
      searchReport: "",
      localShowEdit: this.showEdit,
      currentPage: 1,
      tableKey: 0,
      btnConfigColumns: {
        menu: false,
        icon: "mdi-cog",
        tooltip: "Columnas",
      },
      columnFilter: "",
      localHeaders: this.headers?.map((header) => ({ ...header })),
      loading4: false,
      tagSelected: null,
      showAddTag: false,
      swatches: [
        ["#E10000", "#AA0000", "#550000", "#FF00F1"],
        ["#EAEA12", "#AAAA00", "#555500", "#CD00FF"],
        ["#07B207", "#009000", "#005500", "#800080"],
        ["#32D4D4", "#00AAAA", "#005555", "#373BA8"],
        ["#0000CD", "#0000AA", "#000055", "#4500FF"],
      ],
      name: "",
      description: "",
      color: "#E10000",
      tagDialog: false,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
    };
  },
  watch: {
    headers: {
      handler(newHeaders) {
        this.localHeaders = newHeaders?.map((header) => ({ ...header }));
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    getTags() {
      return this.$store.state.tags.tags.filter((tag) => tag.scope === "reportes");
    },
    getReports() {
      return reports.state.reports.filter(
        (report) => report.permission !== "L"
      );
    },
    filterForTags() {
      if (this.selected.length > 0) {
        return this.changesTags();
      } else {
        return this.items;
      }
    },

    filteredItems() {
      const filtered = this.search
        ? this.items.filter((item) =>
            item.name.toLowerCase().includes(this.search.toLowerCase())
          )
        : this.items;
      if (this.showPagination && this.itemsPerPage) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return filtered.slice(start, start + this.itemsPerPage);
      }
      return filtered;
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.localHeaders?.filter((column) => {
        return column.text?.toLowerCase().includes(filterText);
      });
    },
    visibleHeaders() {
      return this.localHeaders?.filter((column) => column.visible);
    },
  },
  methods: {
    getTagsFilter(report) {
      let tagsFilter = [];
      let repSelected = this.getReports.find((rep) => rep.id === report);

      if (repSelected !== undefined) {
        tagsFilter = this.getTags.filter(
          (tag) =>
            !repSelected.tags.some((empTag) => empTag.etiquetaId === tag.id)
        );
      }
      return tagsFilter;
    },
    async addTag() {
      let payload = {
        nombre: this.name,
        descripcion: this.description,
        color: this.color,
        alcance: "reportes",
      };

      await this.$store.commit("tags/setNewTag", payload);
      await this.$store.dispatch("tags/addTag");
      let tagAdd = this.getTags.find((tag) => tag.text === this.name);

      this.selectedTagsGroup.push(tagAdd.id);
      this.name = "";
      this.description = "";
      this.color = "#E10000";
      this.showAddTag = false;
    },
    async refreshItems() {
      this.loading4 = true;
      try {
        await this.$emit("refreshItems");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },

    headersUpdated() {
      this.$emit("headersUpdated", this.localHeaders);
    },

    calculateMaxHeight() {
      const windowHeight = window.innerHeight;
      // Define multipliers for different window height ranges
      const lowMultiplier = 0.55; // Multiplier for window heights less than 1000 pixels
      const highMultiplier = 0.7; // Multiplier for window heights 1000 pixels or greater

      // Determine multiplier based on window height
      let multiplier = lowMultiplier;
      if (windowHeight >= 1000) {
        multiplier = highMultiplier;
      }

      // Calculate maximum height based on multiplier
      const maxHeight = windowHeight * multiplier;
      return maxHeight;
    },
    updateTableHeight() {
      this.tableHeight = this.calculateMaxHeight();
    },
    handleItemsSelect() {
      this.tagDialog = true;
    },
    cancelDialogTag() {
      this.tagDialog = false;
      this.$refs.form.reset();
      this.selectedRow = null;
      this.selectedTagsGroup = [];
      this.searchEmployeed = "";
      this.searchTag = "";
    },
    removeTag(tag) {
      this.selectedTagsGroup = this.selectedTagsGroup.filter(
        (item) => item !== tag.id
      );
    },
    validateAndSave() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.saveSelectedTags();
      }
    },
    saveSelectedTags() {
      let payload = {
        reportes: this.selectedRow,
        etiquetas: this.selectedTagsGroup,
      };
      reports.commit("setNewTag", payload);
      reports.dispatch("addTagsGroup").then(() => {
        this.cancelDialogTag();
        reports.dispatch("getReports");
      });
    },

    handleChipClick(id) {
      if (this.selected.includes(id)) {
        this.selected = this.selected.filter((selectedId) => selectedId !== id);
      } else {
        this.selected.push(id);
      }
    },
    changesTags() {
      let filteredItems = this.items?.filter((item) => {
        return this.selected?.every((selectedId) => {
          return item.tags?.some((tags) => {
            return tags.etiquetaId === selectedId;
          });
        });
      });
      return filteredItems;
    },
    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    shouldShowDeleteButton(item) {
      return item.editable === undefined ? false : item.editable;
    },
    saveColumnOrder(newIndex, oldIndex) {
      const visibleHeaders = this.localHeaders.filter(
        (header) => header.visible
      );
      const movedColumn = visibleHeaders.splice(oldIndex, 1)[0];
      visibleHeaders.splice(newIndex, 0, movedColumn);
      const newHeaders = [];
      let visibleIndex = 0;
      for (const header of this.localHeaders) {
        if (header.visible) {
          newHeaders.push(visibleHeaders[visibleIndex]);
          visibleIndex++;
        } else {
          newHeaders.push(header);
        }
      }
      this.localHeaders = newHeaders?.map((header) => ({ ...header }));
      this.tableKey++;
      this.$forceUpdate();
    },
  },

  mounted() {
    window.addEventListener("resize", this.updateTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
  directives: {
    sortableColumns: {
      inserted(el, binding) {
        const table = el.querySelector("table");
        const headerRow = table.querySelector("thead tr");
        const sortableHeaders = Array.from(headerRow.children);
        const options = {
          animation: 150,
          ghostClass: "sortable-ghost",
          onEnd: function (event) {
            const newIndex = event.newIndex;
            const oldIndex = event.oldIndex;
            binding.value(newIndex, oldIndex);
          },
        };
        Sortable.create(headerRow, options);
      },
    },
  },
};
</script>

<style scoped>
.add-tag {
  position: relative;
  top: -40px;
  left: 350px;
}
.filter-search-container {
  display: flex;
  align-items: center;
  border-radius: 15px;
  background-color: #a5b9d7;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.search {
  max-width: 500px !important;
}
.autocomplete {
  padding: 0px;
  margin: 0px;
  max-width: 270px;
}
.card_container {
  max-width: 100% !important;
}
.disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;
}
#chip-tags {
  color: #ffffff;
  text-shadow: 0px 1px 4px #000000be;
}
#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-next {
  background-color: #39537a !important;
  color: white !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
